<template>
	<div class="index">
		<div class="index-div">
			<div class="index-conent">
				<div class="index-conent-left">
					<div class="qdetails-left">
						<div class="qdetails-left-div">
							<img class="cimg" :src="info.img|Ximgurl" />
							<div class="qdetails-div-right">
								<div class="qdetails-div-right-div">
									<div class="qdetails-title">{{info.name}}</div>
									<img class="qdetails-headerimg" src="../../assets/shudo/images/u1133.svg" />
								</div>
								<div class="qdetails-zuo">作者：{{info.merchant.username}}</div>
								<div class="qdetails-zuo1">
									<div>{{exercisecount}}人已经完成学习</div>
									<div>{{count}}条留言</div>
								</div>
								<div  class="qdetails-zuo2">
									 {{info.details}}
								</div>
								<div class="qdetails-botton">
									<router-link :to="'/topic/exercise?id='+info.id" >
										<div>进入学习</div>
									</router-link>
									
									<div @click="classifyuseradd()" v-if="classifyusertype==0" >订阅题库</div>
									<div @click="classifyuseradd()" v-if="classifyusertype==1" >取消订阅</div>
									
								</div>
							</div>
						</div>
						<div class="qdetails-left-div1">
							<div @click="classifyuseradd1()">
								<img src="../../assets/shudo/images/u1135.png" />
								<div>{{classifyusercount}}赞</div>
							</div>
							<div  v-clipboard:copy="url" v-clipboard:success="onCopy" >
								
								<img src="../../assets/shudo/images/u1136.png" />
								<div>分享</div>
							</div>
						</div>
					</div>
					<div class="qdetails-conent">
						<div class="qdetails-title">
							<div>目录</div>
						</div>
						<ul  v-for="(item,index) in questionlist" :key="index" v-if="index<=questiontype">
							<li >
								<div>第{{index+1}}题 {{item.name}}</div>
								<div>
									<div>难易度:</div>
									<img v-if="item.difficulty>=1" src="../../assets/9.svg" />
									<img v-if="item.difficulty>=2" src="../../assets/9.svg" />
									<img v-if="item.difficulty>=3" src="../../assets/9.svg" />
									<img v-if="item.difficulty>=4" src="../../assets/9.svg" />
									<img v-if="item.difficulty>=5" src="../../assets/9.svg" />
									<img v-if="item.difficulty<=1" src="../../assets/10.svg" />
									<img v-if="item.difficulty<=2" src="../../assets/10.svg" />
									<img v-if="item.difficulty<=3" src="../../assets/10.svg" />
									<img v-if="item.difficulty<=4" src="../../assets/10.svg" />
								</div>
							</li>
						</ul>
						
						<div class="qdetails-top" v-if="questiontype > 10" @click="questiontypeClick()">展开全部目录</div>
					</div>
					
					<div class="qdetails-conent">
						<div class="qdetails-title1">
							<div @click="tabtypeClick(0)" :class="tabtype==0 ? 'tabtype' : '' ">评论 ({{count}})</div>
							<div @click="tabtypeClick(1)" :class="tabtype==1 ? 'tabtype' : '' ">完成人数 ({{exercisecount}})</div>
							<div style="text-align: right; color: #7F7F7F; margin-left: auto;padding-right: 0.6rem;" @click="iscussAdd(info.id,0)">
								<img style="width: 1.2rem;position: relative;top: 0.3rem;" src="../../assets/shudo/images/u1231.png" />
								<span style="padding-left: 0.3rem;">评论</span>
							</div>
						</div>
						<div class="qdetails-conent-left" v-if="tabtype==0">
							<div v-for="(item,index) in iscuss" :key="index" v-if="iscuss.length > 0">
								<div class="qdetails-conent-left-div" >
									<div class="title">
										<div class="left">
											<div class="left1">
												<img :src="item.user.avatar" />
											</div>
											<div class="right1">
												<div>{{item.user.username}}</div>
												<div>来自 {{info.name}}</div>
											</div>
										</div>
										<div class="right">
											{{item.create_time}}
										</div>
									</div>
									<div class="conent">
										{{item.body}}
									</div>
									<div class="conent">
										<div class="conent-left" @click="iscussAdd(info.id,item.id)">
										<img src="../../assets/shudo/images/u1231.png" />
											<span>回复</span>
										</div>
										<div class="conent-right" @click="discussuser(item.id)">
											<img src="../../assets/shudo/images/u1225.svg" />
											<span>赞同{{item.count}}</span>
										</div>
									</div>
								</div>
								<div class="qdetails-conent-left1" v-for="(it,ind) in item.child" :key="ind" v-if="item.child.length > 0">
									<div class="qdetails-conent-left-div">
										<div class="title">
											<div class="left">
												<div class="left1">
													<img src="../../assets/shudo/images/8.svg" />
												</div>
												<div class="right1">
													<div>{{it.user.username}}</div>
													<div>来自 {{info.name}}</div>
												</div>
											</div>
											<div class="right">
												{{it.create_time}}
											</div>
										</div>
										<div class="conent">
											{{it.body}}
										</div>
										<div class="conent">
											
											<div class="conent-right" @click="discussuser(it.id)">
												<img src="../../assets/shudo/images/u1225.svg" />
												<span>赞同{{it.count}}</span>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						
						<div class="qdetails-conent-right" v-if="tabtype==1">
							
							<div class="qdetails-conent-right1" >
								<div class="qdetails-conent-right-div"  v-for="(item,index) in exerciselist" :key="index" v-if="exerciselist.length > 0">
									<div class="dss">
										<img :src="item.user.avatar" />
										<div>
											<div class="div">
												<span>{{item.user.username}}</span>
												<span>完成 {{item.percentage}} 题</span>
											</div>
											<div class="div1">
												<span>来自</span>
												<span>{{item.user.nationality?item.user.nationality : '-'}}{{item.user.city?item.user.city:'-'}}</span>
											</div>
											<div class="div2">{{item.create_time}}</div>
										</div>
										
									</div>
									
								</div>
								
							</div>	
							
						</div>
						
						
						<!-- <div class="qdetails-top">展开全部目录</div> -->
					</div>
				</div>
				<div class="index-conent-right">
					<div class="header">
						<div>加入题库作者</div>
					</div>
					<div class="conent">
						<router-link to="/dingyue">
							<div class="conont-div">
								<img src="../../assets/shudo/images/u1207.png" />
								<div>我的订阅</div>
							</div>
						</router-link>
						<!-- <router-link :to="'/exercise/list?classify_id='+id"> -->
						<div class="conont-div">
							<img src="../../assets/shudo/images/u1208.png" />
							<div>我的记录</div>
						</div>
						<!-- </router-link> -->
					</div>
					<div class="conent1">
						<div class="conont-title">
							<div>作者信息</div>
						</div>
						<div class="conont-title1">
							<img :src="info.merchant.avatar">
							<div>
								<div class="title1">{{info.merchant.username}}</div>
								<div class="title2">中国|杭州</div>
							</div>
						</div>
						<div class="conont-title2">
							{{info.merchant.brief}}
						</div>
					</div>
					
					
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
	    data() {
			return {
				url : 'http://baidu.com',
				tabtype : 0,
				info    : [],
				questionlist : [], //试题
				questiontype : 5,
				count : 0,
				id           : '',
				exerciselist : [],
				exercisecount: 0,
				classifyusertype : 0,
				classifyusercount: 0,
				iscuss : [{
					'child': []
					}
				]
			}
		},
		created() {
			let that    = this;
			var  query  = this.$route.query;
			that.url    = window.location.href;
			if(query.id){
				that.id = query.id;
				that.infoList(query.id);
				that.infoiscuss(query.id)
			}
		},
		methods:{
			onCopy(e){ 　　 // 复制成功
		　　　　this.$message({
		　　　　　　message:'复制成功！',
		　　　　　　type:'success'
		　　　　})
		　　},
			discussuser(discuss_id){
				let that = this;
				that.$http('post','/api/v1/iscuss/discussuseradd',{'discuss_id':discuss_id}) .then(function (res) {
					if(res.code==200){
						that.infoiscuss(that.info.id);
						that.$message({ showClose: true,message: res.msg,type: 'success'});
					}else{
						that.$message({ showClose: true,message: res.msg,type: 'error'});
					}
				});
			},
			iscussAdd(id,pid){
				let that = this;
				that.$prompt('请输入评论内容', '提示', {
				  confirmButtonText: '确定',
				  cancelButtonText: '取消',
			
				}).then(({ value }) => {
					that.$http('post','/api/v1/iscuss/add',{'id':id,'type':1,'body':value,'pid':pid}) .then(function (res) {
						if(res.code==200){
							that.infoiscuss(id);
							that.$message({ showClose: true,message: res.msg,type: 'success'});
						}else{
							that.$message({ showClose: true,message: res.msg,type: 'error'});
						}
					});
				}).catch(() => {
				  that.$message({
					type: 'info',
					message: '取消输入'
				  });       
				});
			},
			classifyuseradd(){
				let that = this;
				that.$http('post','/api/v1/classify/classifyuseradd',{type:0,classify_id:that.id}) .then(function (res) { 
					that.$message({ showClose: true,message: res.msg,type: 'success'});
					that.infoList(that.id);
				});
				
			},
			classifyuseradd1(){
				let that = this;
				that.$http('post','/api/v1/classify/classifyuseradd',{type:1,classify_id:that.id}) .then(function (res) { 
					that.$message({ showClose: true,message: res.msg,type: 'success'});
					that.infoList(that.id);
				});
			},
			questiontypeClick(){  //查看全部试题
				this.questiontype = 1000;
			},
			infoiscuss(id){
				let that = this;
				that.$http('get','/api/v1/iscuss/list',{type:1,three_id:id}) .then(function (res) {  //评论列表
					that.iscuss  = res.data.list;
					that.count  = res.data.count;
					console.log(res.data);
				});
			},
			tabtypeClick(e){
				this.tabtype  = e;
			},
			copy() {  
				var clipboard = new Clipboard('.tag-read')  
				clipboard.on('success', e => {  
					success("复制成功");//这里你如果引入了elementui的提示就可以用，没有就注释即可
					  // 释放内存  
					  clipboard.destroy()  
					})  
				clipboard.on('error', e => {  
					// 不支持复制  
					console.log('该浏览器不支持自动复制')  
					// 释放内存  
					clipboard.destroy()  
				})  
			},
			infoList(id){
				let that  = this;
				that.$http('get','/api/v1/classify/details',{id:id}) .then(function (res) {  //联系方式
					
					that.info = res.data.info;
					
				});
				that.$http('get','/api/v1/question/list',{classify_id:id}) .then(function (res) {  //联系方式
					that.questiontype  = res.data.list.length;
					that.questionlist = res.data.list;
				});
				that.$http('get','/api/v1/question/exerciselist',{classify_id:id}) .then(function (res) {  //完成人数
					
					that.exerciselist = res.data.list;
					that.exercisecount= res.data.list.length; 
				});
				that.$http('get','/api/v1/classify/classifyuserinfo',{classify_id:id,type:0}) .then(function (res) {  //是否操作过
					console.log(res);
					if(res.data.info){
						that.classifyusertype  = 1;
					}else{
						that.classifyusertype  = 0;
					}
					
				});
				that.$http('get','/api/v1/classify/classifyuserinfo',{classify_id:id,type:1}) .then(function (res) {  //点赞人数
					that.classifyusercount = res.data.count;
					
				});
				
				
				
			}
		},
	}
</script>

<style lang="less">
	@import  '../../../common/css/index.less';
	.index-conent-left {
		color: #7F7F7F;
		.qdetails-left {
			width: 100%;
			background-color: #FFFFFF;
			.qdetails-left-div {
				width: 100%;
				padding: 1rem;
				display: flex;
				img {
					width: 12rem ;
				}
				
				.qdetails-div-right {
					padding-left: 1.5rem;
					width: 30.5rem;
					.qdetails-div-right-div {
						display: flex;
						.qdetails-headerimg {
							width: 1.5rem;
						}
						.qdetails-title {
							flex: 3;
						     font-size: 1.2rem;
						}
					}
					.qdetails-zuo {
						font-size: 0.8rem;
					}
					.qdetails-zuo1 {
						display: flex;
						div:nth-last-child(2){
							padding-right: 1rem;
							font-size: 0.6rem;
						}
						div:nth-last-child(1){
							font-size: 0.6rem;
						}
					}
					.qdetails-zuo2 {
						padding-top: 0.6rem;
						text-indent:2em;
						font-size: 0.6rem;
					}
					.qdetails-botton{
						display: flex;
						div{
							border-radius: 0.2rem;
							font-size: 0.6rem;
							width: 6rem;
							line-height: 1.6rem;
							height: 1.6rem;
							background-color: rgba(217, 0, 27, 1);
							margin: 1rem;
							color: #FFFFFF;
							text-align: center;
						}
						div:nth-last-child(2){
							margin-left: 15.5rem;
						}
						
					}
				}
				
			}
			.qdetails-left-div1 {
				border-top: 1px solid #7f7f7fad;
				display: flex;
				font-size: 0.6rem;
				height: 2.6rem;
				div:nth-last-child(2){
					display: flex;
					margin-left: 1rem;
					img {
						width: 1.8rem;
						height: 1.8rem;
						position: relative;
						top: 0.1rem;
					}
					line-height: 2.2rem;
				}
				div:nth-last-child(1){
					display: flex;
					margin-right: 1rem;
					line-height: 2.2rem;
					
					img {
						position: relative;
						top: 0.7rem;
						width: 0.8rem;
						height: 0.8rem;
						padding-right: 0.2rem;
					}
				}
			}
		  
		}
		.qdetails-conent {
			margin-top: 1rem;
			width: 100%;
			background-color: #FFFFFF;
			min-height: 6rem;
			padding-bottom: 0.5rem;
			.qdetails-title {
				display: flex;
				border-bottom:  1px solid #7f7f7fad;
				height: 2rem;
				line-height: 2rem;
				div {
					font-size: 0.8rem;
					font-weight: 600;
					text-align: center;
					margin-left: 1.1rem;
					min-width: 2rem;
					height: 2.01rem;
					padding-left: 0.2rem;
				}
				div:nth-last-child(1){
					border-bottom:  2px solid rgba(217, 0, 27, 1);
				}
			}
			.qdetails-title1 {
				display: flex;
				border-bottom:  1px solid #7f7f7fad;
				height: 2rem;
				line-height: 2rem;
				div {
					font-size: 0.8rem;
					font-weight: 600;
					text-align: center;
					margin-left: 1.1rem;
					min-width: 2rem;
					height: 2.01rem;
					padding-left: 0.2rem;
				}
				
			}
			.tabtype { border-bottom:  2px solid rgba(217, 0, 27, 1);}
			ul {
				font-size: 0.8rem;
				border-bottom: 1px solid #7f7f7f17;
				li{
					width: 100%;
					height: 2rem;
					div:nth-last-child(2){
						float: left;
						width: 50%;
					}
					div:nth-last-child(1){
						float: left;
						display: flex;
						div {
							width: 3rem;
						}
						img {
							position: relative;
							top: 0.2rem;
							margin-left: 0.1rem;
							width: 0.75rem;
							height: 0.6875rem;
						}
					}
					
				}
			}
			.qdetails-top {
				height: 2rem;
				line-height: 2rem;
				text-align: center;
				color: #027DB4;
				padding-top: 1rem;
			}
			.qdetails-conent-left {
				width: 100%;
				border-bottom: 1px solid #7f7f7f17;
				padding-bottom: 0.3rem;
				.qdetails-conent-left-div {
					width: 96%;
					margin: auto;
					margin-top: 0.8rem;
					min-height: 3.5rem;
					.title {
						width: 100%;
						display: flex;
						height: 2rem;
						.left {
							display: flex;
							.left1 {
								width: 2rem;
								img {
									width: 100%;
								}
							}
							.right1 {
								margin-left: 0.5rem;
								line-height: 1rem;
								font-size: 0.6rem;
							}
						}
						.right {
							font-size: 0.6rem;
							margin-left: auto;
						}
					}
					.conent {
						padding-top: 0.5rem;
						min-height: 1rem;
						font-size: 0.6rem;
						margin-left: 2.5rem;
						display: flex;
						.conent-left {
							img{
								width: 1rem;
								position: relative;
								top: 0.2rem;
							}
							span {
								padding-left: 0.6rem;
							}
						}
						.conent-right{
							margin-left: auto;
							img {
								position: relative;
								top: 0.1rem;
							}
							span {
								padding-left: 0.4rem;
							}
						}
					}
				}
				
			}
			
			.qdetails-conent-left1 {
				width: 100%;
				border-bottom: 1px solid #7f7f7f17;
				padding-bottom: 0.3rem;
				.qdetails-conent-left-div {
					width: 96%;
					margin: auto;
					margin-top: 0.8rem;
					min-height: 3.5rem;
				
					.title {
						width: 100%;
						display: flex;
						height: 2rem;
						.left {
							display: flex;
							margin-left: 2rem;
							.left1 {
								width: 2rem;
								img {
									width: 100%;
								}
							}
							.right1 {
								margin-left: 0.5rem;
								line-height: 1rem;
								font-size: 0.6rem;
							}
						}
						.right {
							font-size: 0.6rem;
							margin-left: auto;
						}
					}
					.conent {
						padding-top: 0.5rem;
						min-height: 1rem;
						font-size: 0.6rem;
						margin-left: 4.5rem;
						
						display: flex;
						.conent-left {
							img{
								width: 1rem;
								position: relative;
								top: 0.2rem;
							}
							span {
								padding-left: 0.6rem;
							}
						}
						.conent-right{
							margin-left: auto;
							img {
								position: relative;
								top: 0.1rem;
							}
							span {
								padding-left: 0.4rem;
							}
						}
					}
				}
				
			}
			
			.qdetails-conent-right {
				width: 100%;
				
				.qdetails-conent-right1 {
					width: 100%;
					display: flex;
					flex-wrap: wrap;
					border-bottom: 1px solid #7f7f7f17;
					.qdetails-conent-right-div {
						width: 33%;
						display: flex;
						flex-wrap: wa;
						height: 6.9rem;
						
						.dss {
							width: 85%;
							margin: auto;
							display: flex;
							height: 4rem;
							border-right: 1px solid #7f7f7f17;
							margin-top: 1.5rem;
							img {
								width: 2rem;
								height: 2rem;
							}
							.div {
								padding-left: 0.2rem;
								font-size: 0.6rem;
								line-height: 1rem;
								span{
									padding: 0.2rem;
								}
								span:nth-last-child(2){
									font-weight: 600;
								}
							}
							.div1 {
								padding-left: 0.2rem;
								font-size: 0.6rem;
								line-height: 1.5rem;
								
								span{
									padding: 0.2rem;
								}
								span:nth-last-child(1){
									font-weight: 600;
								}
							}
							.div2 {
								line-height: 1.6rem;
								padding-left: 0.2rem;
								font-size: 0.6rem;
							}
						}
						
						
					}
				}
				
			}
		}
		
	}
	.index-conent-right {
		.header {
			background-image: url(../../assets/shudo/images/u1145.jpg);
			// background-image: url('http://jinbangsai.net/shudu/images/%E9%A2%98%E5%BA%93%E8%AF%A6%E6%83%85/u1145.jpg');
			width: 100%;
			height: 10rem;
			background-size: 100%;
			div{
				background-color: #FFFFFF;
				width: 6rem;
				margin-left: auto;
				margin-right: auto;
				position: relative;
				top: 7rem;
				text-align: center;
				border-radius: 0.2rem;
				height: 1.6rem;
				line-height: 1.6rem;
				font-size: 0.6rem;
				color: #000000;
			}
		}
		.conent {
			height: 6rem;
			margin-top: 1rem;
			background-color: #FFFFFF;
			.conont-div {
				height: 3rem;
				display: flex;
				border-bottom:  1px solid #7f7f7fad;
				img {
					margin-top: 0.6rem;
					height: 1.3rem;
					width: 1.3rem;
					margin-left: 1rem;
				}
				div {
					padding-left: 0.6rem;
					font-size: 1rem;
					color: #7F7F7F;
					line-height: 2.5rem;
				}
			}
			.conont-div:nth-last-child(1){ border-bottom:none }
		}
		.conent1 {
			min-height: 6rem;
			margin-top: 1rem;
			background-color: #FFFFFF;
			.conont-title {
				line-height: 2rem;
				
				height: 2rem;
				color: #7F7F7F;
				font-size: 1rem;
				border-bottom:  1px solid #7f7f7fad;
				div {
					width: 4rem;
					padding-left: 0.6rem;
					border-bottom: 2px solid #d9001b;
				}
			}
			.conont-title1 {
				display: flex;
				height: 4rem;
				img {
					margin-top: 0.8rem;
					margin-left: 1rem;
					width: 2.5rem;
					height: 2.5rem;
				}
				div {
					padding-left: 0.4rem;
					color: #7F7F7F;
					// padding-top: 0.7rem;
					.title1 {
						padding-top: 0.6rem;
						font-size: 1.2rem;
					}
					.title2 {
						font-size: 0.8rem;
					}
				}
			}
			.conont-title2 {
				width: 90%;
				margin: auto;
				color: #7F7F7F;
				text-indent:2em;
				padding-bottom: 2rem;
				font-size: 0.6rem;
			}
		}
		
		
		
	}
</style>
